var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "#24A95D",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8057 0.0712891C11.8974 0.0712891 9.0543 0.921699 6.63607 2.51498C4.21784 4.10826 2.33306 6.37285 1.22007 9.02238C0.10708 11.6719 -0.184129 14.5874 0.383268 17.4001C0.950665 20.2128 2.35118 22.7965 4.40772 24.8243C6.46425 26.8522 9.08444 28.2332 11.9369 28.7927C14.7894 29.3522 17.7461 29.065 20.4331 27.9675C23.1201 26.8701 25.4167 25.0116 27.0325 22.6271C28.6483 20.2425 29.5108 17.4391 29.5108 14.5713C29.5108 10.7256 27.9615 7.03752 25.2038 4.31824C22.446 1.59896 18.7058 0.0712891 14.8057 0.0712891ZM21.1079 18.7141C21.1079 19.2635 20.8866 19.7904 20.4926 20.1789C20.0987 20.5673 19.5643 20.7856 19.0072 20.7856H10.6043C10.0472 20.7856 9.51284 20.5673 9.11888 20.1789C8.72492 19.7904 8.50359 19.2635 8.50359 18.7141V10.4284C8.50359 9.87905 8.72492 9.35218 9.11888 8.96371C9.51284 8.57524 10.0472 8.357 10.6043 8.357H19.0072C19.5643 8.357 20.0987 8.57524 20.4926 8.96371C20.8866 9.35218 21.1079 9.87905 21.1079 10.4284V18.7141Z",
    fill: "#24A95D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.8b93c414a275499649c1f385eb3a4dc5.svg";
export { ForwardRef as ReactComponent };